var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHandRight = function SvgHandRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 37,
    height: 35,
    viewBox: "0 0 0.84 0.81",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.26.8C.1.75.14.59.05.45.03.42-.04.33.03.32c.13-.02.13.2.22.2C.31.51.27.32.27.27.27.23.25.04.27.01s.07.01.08.06C.36.11.34.33.38.32.42.32.4-.01.49.03.58.07.44.35.5.34.55.33.6.19.6.15.62 0 .77.05.7.17.68.2.58.36.61.39.63.41.72.2.77.21.98.26.62.44.6.61.58.78.39.84.26.8z",
    fill: "#000"
  })));
};

export default SvgHandRight;